export default "__VITE_ASSET__0e613133__"